module.exports = __webpack_public_path__ + "img/solvency-red.ee631e5c.svg";